import React, { useState, useEffect } from 'react';
import { useAuth } from '@/context/AuthContext';
import Layout from '../components/Layout';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import ReviewQRCode from '../components/ReviewQRCode';
import ReviewsSection from '../components/ReviewsSection';
import { Star, MessageSquare } from 'lucide-react';
import { toast } from 'sonner';

export default function Reviews() {
  const { agent } = useAuth();
  const [loading, setLoading] = useState(true);
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    fetchUserData();
  }, []);

  const fetchUserData = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/agent/public-profile`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      if (response.ok) {
        const data = await response.json();
        setUserData({
          id: data.id,
          role: data.role || 'agent',
          name: data.name
        });
      }
    } catch (error) {
      console.error('Error fetching user data:', error);
      toast.error('Failed to load data');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Layout>
        <div className="flex items-center justify-center h-64">Loading...</div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="max-w-6xl mx-auto p-6 space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-xl sm:text-2xl md:text-3xl font-bold text-[#1A4D2E] flex items-center gap-2">
              <Star className="text-[#1A4D2E]" size={32} />
              Customer Reviews
            </h1>
            <p className="text-stone-600 mt-1">Manage and view your customer reviews</p>
          </div>
        </div>

        {/* Reviews List */}
        {userData && userData.id && (
          <ReviewsSection 
            userType={userData.role} 
            userId={userData.id}
            showManagement={true}
            token={localStorage.getItem('token')}
          />
        )}
      </div>
    </Layout>
  );
}
